/**
 * Checks if an array object is not undefined and has items
 * @param array any array object
 * @returns True if there the object has at least one item
 */
export const hasItems = <T>(array?: T[] | null): array is T[] =>
  Boolean(array && array.some((o) => o !== undefined));
